import * as React from 'react';

import { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxHeader, CtaBoxText } from 'components/cta-box';
import GoodToKnow from 'components/good-to-know/good-to-know';
import PageSection from 'components/page/page-section';
import PageSectionCtaWithoutImage from 'components/page/sections/page-section-cta-without-image';
import Table from 'components/table/table';
import { FormattedText, Header3, P1 } from 'components/typography';

import { getPropsSectionNineContainer } from './section-nine-container.props';

export const SectionNineContainer: React.FC = () => {
  const props = getPropsSectionNineContainer();
  return (
    <>
      <PageSectionCtaWithoutImage
        text={
          <CtaBox align="start">
            <CtaBoxHeader tag="h2">{props.sections.one.title}</CtaBoxHeader>
            <CtaBoxText>{props.sections.one.text}</CtaBoxText>
          </CtaBox>
        }
        imageText={
          <GoodToKnow
            color="primary"
            title={props.sections.one.goodToKnow.title}
            content={props.sections.one.goodToKnow.content}
          />
        }
        columnLeft={{ size: ColumnsSize['1/3'] }}
        columnRight={{ size: ColumnsSize['2/3'] }}
        color="transparent"
      />
      <PageSection color="peach" padding="block" inner={true}>
        <FormattedText>
          <Header3 as="h3">{props.sections.usa.rights.item1.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item1.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item2.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item2.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item3.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item3.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item4.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item4.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item5.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item5.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item6.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item6.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item7.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item7.content()} />

          <P1 as="p" html={props.sections.usa.rights.item8.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item9.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item9.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item10.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item10.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item11.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item11.content()} />

          <Header3 as="h3">{props.sections.usa.rights.item12.title()}</Header3>
          <P1 as="p" html={props.sections.usa.rights.item12.content()} />
        </FormattedText>

        <FormattedText>
          <br />
          <br />
          <Table rows={props.sections.usa.grid} th={true} />
          <br />
          <br />
        </FormattedText>

        <FormattedText>
          <Header3 as="h3">{props.sections.usa.students.title()}</Header3>
          <P1 as="p" html={props.sections.usa.students.text1()} />
          <P1 as="p" html={props.sections.usa.students.text2()} />
          <P1 as="div" html={props.sections.usa.students.text3()} />
          <P1 as="p" html={props.sections.usa.students.text4()} />
        </FormattedText>
      </PageSection>
    </>
  );
};
